export interface MeVisibilityDto {
  visible_to_employers: boolean;
}
